<template>
  <div class="servicehead-grid-container">
    <div>
      <img class="head-grid-logo" src="../assets/logo-WMADCC_FNL.jpg">
    </div>

    <div class="head-grid-video">
      <video src="../assets/BirthdayVideo.mp4" controls></video>
    </div>
  </div>
</template>
  
<script>
  export default {
    name: 'ServiceHeader'
  }
</script>
  
<style scoped>

/* for desktop */
@media (min-width:701px) {

  .servicehead-grid-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    background-color: rgb(255, 243, 224);
    height: 20vw;
    margin-bottom: 1vw;
  }

  .head-grid-logo {
    display: flex;
    width: 30vw;
    height: 18vw;
    padding: 1vw;
    margin-left: 7vw; 
  }

  .head-grid-video {
    display: flex;
    width: 32vw;
    height: 19vw;
    padding: 0.5vw;
    margin-left: 6vw;
  }
}


/* for Phone */
@media (max-width:700px) {

  .head-grid-logo {
    width: 15rem;
    height: auto;
  }

  video {
    width: 0rem;
    height: 0rem;
  }  
}

</style>
